import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../api';
import { Grid, Message, Icon, Button } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './CotsClientManager.css';

function mapStateToProps(state) {
    return {
        // map state to props if necessary
    };
}

function mapDispatchToProps(dispatch) {
    return {
        // map dispatch to props if necessary
    };
}

class CotsClientManager extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clientList: [],
            cots: [],
            fullCots: []
        };
    }

    componentDidMount() {
        this.fetchClientData();
    }

    fetchClientData = () => {

        return Promise.all([
            api.getCustomerList(),
            api.getCotsClients(),
            api.getFullCotsClients(),])
            .then(([custList,cotsClientList,fullCotsClientList]) =>
            {
        this.setState({clientList: custList,
            cots: cotsClientList.map(item => item.clientId) ,
             
              fullCots: fullCotsClientList.map(item => item.clientId)
            })
    });
}



    moveClients = (source, target, clients) => {
        const sourceClients = this.state[source].filter(client => !clients.includes(client));
        const targetClients = [...this.state[target], ...clients];

        clients.forEach(clientId => {
            const clientName = this.state.clientList.find(client => client.custKey === clientId).name;
            if (source === 'clientList' && target === 'cots') {
                api.addCotsClient(clientId, clientName).catch(error => console.error(error));
            } else if (source === 'cots' && target === 'clientList') {
                api.removeCotsClient(clientId).catch(error => console.error(error));
            } else if (source === 'cots' && target === 'fullCots') {
                api.addFullCotsClient(clientId, clientName).catch(error => console.error(error));
                api.removeCotsClient(clientId).catch(error => console.error(error));
            } else if (source === 'fullCots' && target === 'cots') {
                api.addCotsClient(clientId, clientName).catch(error => console.error(error));
                api.removeFullCotsClient(clientId).catch(error => console.error(error));
            }
        });

        this.setState({
            [source]: sourceClients,
            [target]: targetClients
        });
    };

    render() {
        const availableClients = this.state.clientList
        .filter(client => !this.state.cots.includes(client.custKey) && !this.state.fullCots.includes(client.custKey))
        .map(client => ({
            value: client.custKey,
            label: client.name || 'Unknown ICMAS KEY - (' + id + ')', // Fallback to 'Unknown' if name is null or undefined
        }));
    
    const cotsClients = this.state.cots
        .map(id => {
            const client = this.state.clientList.find(client => client.custKey === id);
            return {
                value: id,
                label: client?.name || 'Unknown ICMAS KEY - (' + id + ')', // Use optional chaining and fallback
            };
        });
    
    const fullCotsClients = this.state.fullCots
        .map(id => {
            const client = this.state.clientList.find(client => client.custKey === id);
            return {
                value: id,
                label: client?.name || 'Unknown ICMAS KEY - (' + id + ')', // Use optional chaining and fallback
            };
        });
    

        return (
            <div className="main-container">
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Message warning>
                                <Icon size='large' name='warning sign' />
                                <b>Please note: </b> Use the lists below to configure clients as COTS or FullCOTS.
                            </Message>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={3}>
                        <Grid.Column>
                            <h3>Available Clients</h3>
                            <div className="list-box">
                                {availableClients.map(client => (
                                    <div key={client.value} className="list-item">
                                        {client.label}
                                        <Button icon onClick={() => this.moveClients('clientList', 'cots', [client.value])}>
                                            <Icon name="arrow right" />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <h3>Site Amendments</h3>
                            <div className="list-box">
                                {cotsClients.map(client => (
                                    <div key={client.value} className="list-item">
                                        <Button icon onClick={() => this.moveClients('cots', 'clientList', [client.value])}>
                                            <Icon name="arrow left" />
                                        </Button>
                                        {client.label}
                                        <Button icon onClick={() => this.moveClients('cots', 'fullCots', [client.value])}>
                                            <Icon name="arrow right" />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <h3>COT&apos;S Contracted</h3>
                            <div className="list-box">
                                {fullCotsClients.map(client => (
                                    <div key={client.value} className="list-item">
                                        <Button icon onClick={() => this.moveClients('fullCots', 'cots', [client.value])}>
                                            <Icon name="arrow left" />
                                        </Button>
                                        {client.label}
                                    </div>
                                ))}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default wrap(CotsClientManager);
